// SCHRIFTWECHSEL
export const SCHRIFTWECHSELART_VALUES = [
  { text: 'Versicherungsschein/Nachträge', value: '1', tooltip: '' },
  { text: 'Rechnungen/Mahnungen', value: '4', tooltip: '' },
  {
    text: 'Hauptfälligkeitsschreiben',
    value: '8',
    tooltip: 'Inhalt: BAK-Vorabinfo VN, Jahres-Prenotifikation VN, Stammdatenänderungen VN und Risikoänderungen'
  },
  {
    text: 'Meldebögen',
    value: '16',
    tooltip: 'Meldebögen für KOMPEX, KOMedEX, AGROMEX, Verkehrs-Rechtsschutz für Selbstständige, Immobilien-Rechtsschutz und Vermieter-Rechtsschutz'
  },
  { text: 'Sonstiger Schriftwechsel', value: '2', tooltip: '' }
];
export const VSSN_VALUE = "1";
export const SS_VALUE = "2";

//RECHTSFORMEN
export const RECHTSFORM_VALUES = [
  // { text: "AG", value: "AG" },
  // { text: "AG & Co. KG", value: "AG & Co. KG" },
  { text: "Einzelunternehmen", value: "Einzelunternehmen" },
  { text: "Freiberufler", value: "Freiberufler" },
  { text: "Gbr", value: "Gbr" },
  { text: "GmbH", value: "GmbH" },
  // { text: "GmbH & Co. KG", value: "GmbH & Co. KG" },
  { text: "KG", value: "KG" },
  // { text: "KGaA", value: "KGaA" },
  { text: "Ltd.", value: "Ltd." },
  { text: "OHG", value: "OHG" },
 // { text: "Stiftung", value: "Stiftung" },
 // { text: "Stille Gesellschaft", value: "Stille Gesellschaft" },
  { text: "UG", value: "UG" },
 // { text: "Versicherungsverein auf Gegenseitigkeit", value: "VVaG" },
 // { text: "Verein", value: "Verein" },
  { text: "e.G.", value: "e.G." },
  { text: "e.K.", value: "e.K." },
 // { text: "e.V.", value: "e.V." },
  { text: "gGmbH", value: "gGmbH" },
  { text: "Sonstige", value: "Sonstige" }
];

//MAKLERVERBUNDE
export const MAKLERVERBUND_VALUES = [
  { text: 'BMVF (Bundesverband mittelständischer Versicherungs- und Finanzmakler)', value: 'BMVF' },
  { text: 'BVK (Bundesverband Deutscher Versicherungskaufleute)', value: 'BVK' },
  { text: 'IGVM (Interessengemeinschaft deutscher Versicherungsmakler)', value: 'IGVM' },
  { text: 'VDVM (Verband deutscher Versicherungsmakler)', value: 'VDVM' },
  { text: 'VFV (Maklerverbund Sachsen)', value: 'VFV' },
  { text: 'Kein Mitglied eines Maklerverbundes', value: '0' }
];

export const ONBOARDING_PAGES = [
  {
    header: "Noch schneller <br> zum Angebot und Abschluss",
    html: "Mit übersichtlicher Produktmatrix zum bedarfsgerechten Angebot, schnelle Erstellung und einfache Berechnung. <br> In nur wenigen Klicks zum Antrag!<br>Noch anwenderfreundlicher für Makler dank modernstem Design und sicherer Web-Technologie. <br> Auch von mobilen Geräten nutzbar.",
    icon: "insert_drive_file",
  },
  {
    header: "Bestandsverträge ",
    text: "Änderungen in Verträgen ganz einfach selbst durchführen: Leistungsumfang, Adressdaten, Bankverbindung u.v.m.",
    icon: "library_books",
  },
  {
    header: "Kundenverwaltung",
    text: "Komfortable Übersicht über Anträge, Angebote, Verträge und Schäden Ihrer Kunden.",
    icon: "visibility"
  },
  {
    header: "Maklerservice und Vertriebsunterstützung",
    text: "Persönliche Ansprechpartner, umfassende Verkaufshilfen und schnelle Unterstützung bei allen Problemen Ihrer Kunden.",
    icon: "sms",
  }
];
